import { repositories } from './http-repositories'

export { repositories }
export const taskRepository = repositories.tasks
export const commerceRepository = repositories.commerce
export const creditRepository = repositories.credits
export const developerRepository = repositories.developer
export type {
  CommerceRepository,
  CreditRepository,
  DeveloperRepository,
  TaskRepository,
} from '../contracts/repositories'
